<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
    <div style="background: #FFFFFF;text-align: center">
      <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
      <h1 class="acr-dialog-title">导入资产</h1>
      <el-upload drag :http-request="uploadFile" action="" :show-file-list="false">
        <em class="el-icon-upload"></em>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="height: 20px;"></div>
    </div>
  </el-dialog>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "ImportPropertyCode",
  data() {
    return {
      dialogFormVisible: false,
    }
  },
  methods: {
    uploadFile(fileObj) {
      Message({
        showClose: true,
        message: '导入中，请等待导入结果ε=ε=ε=(~￣▽￣)~',
        type: 'info'
      });
      let formData = new FormData();
      formData.set("file", fileObj.file);
      AxiosBase.axiosPut("/property-ad/import-property-code", formData, {
        headers: {
          "Content-type": "multipart/form-data"
        }
      }).then(response => {
        if (response !== 0) {
          this.$parent.$parent.getPropertyCodeData();
          this.dialogFormVisible = false;
          this.$message({
            type: 'success',
            message: response.data
          });
        }
      })
    }
  }
}
</script>